export const gValidWidgetTypes = Object.freeze([
  'label',
  'eventButton',
  'variableDisplay',
  'digitalInputDisplay',
  'console',
  'dropdown',
  'numericInput',
  'custom'
]);
